import { Route } from 'react-router-dom';
import { SupportDocumentationPage } from './pages/SupportDocumentationPage.js';
import { SupportGetSupportPage } from './pages/SupportGetSupportPage.js';

/**
 * Support — documentation + get-support pages. Both real (no
 * placeholders) but lean: external links + an email-prefilled
 * "open ticket" CTA. Phase B replaces the mailto with a real
 * support-ticket endpoint.
 */
export function supportRoutes(): JSX.Element {
  return (
    <>
      <Route path="/support" element={<SupportDocumentationPage />} />
      <Route path="/support/get-support" element={<SupportGetSupportPage />} />
    </>
  );
}
